import { AmbientLight, DirectionalLight, HemisphereLight, Light } from "three";
import { directionalPosition } from "./directional-position";
import { gammaCorrect } from "../color/gamma-correct";

export const makeKitchenLights = (alt: number, az: number): Light[] => {
    var result: Light[] = new Array();
    var mainLight = new DirectionalLight(0xFFFFFF,  Math.PI * 0.5);
    mainLight.castShadow = true;

    directionalPosition(mainLight, alt, az);

    mainLight.shadow.camera.near = 1;
    mainLight.shadow.camera.far = 350;
    mainLight.shadow.camera.right = 400;
    mainLight.shadow.camera.left = -400;
    mainLight.shadow.camera.top = 400;
    mainLight.shadow.camera.bottom = -400;
    mainLight.shadow.mapSize.width = 4096;
    mainLight.shadow.mapSize.height = 4096;

    mainLight.shadow.bias = -0.001;
    mainLight.shadow.normalBias = -0.002;

    result.push(mainLight);

    const hemi = new HemisphereLight(
        gammaCorrect(0xFFFFFF), // zenith
        gammaCorrect(0x000000), // ground
        Math.PI/2);
    directionalPosition(hemi, alt, az);
    result.push(hemi);

    const ambient = new AmbientLight(gammaCorrect(0XFFF4F2), Math.PI/2);
    result.push(ambient);

    mainLight.layers.enable(1);
    hemi.layers.enable(1);
    ambient.layers.enable(1);

    return result;
};

export default makeKitchenLights;
